module.exports = __webpack_public_path__ + "img/plamen5kov.3ad6e3e9.jpg";